module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/party-sdp.jpg?v=c3a990ae";